import fetch from 'node-fetch';
import { ApolloClient, InMemoryCache, createHttpLink, from } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';

const getVariables = () => {
  // var id = '5ukizm4qjnhafhoi6txum2disy';
  // var key = 'da2-zi7bck2hszclloj4fo2hczgche';
  // var apiEndpoint = 'https://4sp7v54bnvgnfgnbewjxz3rbz4.appsync-api.ap-southeast-2.amazonaws.com/graphql';

  console.log('JAYCO_GRAPHQL_API_PRODUCTION_URL', process.env.JAYCO_GRAPHQL_API_PRODUCTION_URL);

  if (typeof window !== 'undefined' &&
    ((window.location.hostname === 'preview.jayco-com-au.staticlylocal.com' || window.location.hostname === 'localhost')
    // Add links here for staging
  )) {
    return {
      id: 'hv5gwdgwcjbh3dafl44p7bjebe',
      key: 'da2-6wzdt6rrojbv5apvcy3i2olgne',
      apiEndpoint: 'https://yirivsskf5batig6dxh6m2igqm.appsync-api.ap-southeast-2.amazonaws.com/graphql',
    }
  }

  // @TODO - update - at the moment if it's server side it will get development variables
  if (typeof window !== 'undefined' &&
    ((window.location.hostname === 'www.jayco.com.au' ||
    window.location.hostname === 'jayco.com.au' ||
    window.location.hostname === 'www.jayco.co.nz' ||
    window.location.hostname === 'jayco.co.nz' ||
    window.location.hostname === 'static-master.jayco-com-au.au1.staticlyproject.com' || window.location.hostname === 'static-master.jayco-co-nz.au1.staticlyproject.com')
    // Add links here for staging
  )) {
    return {
      id: process.env.JAYCO_GRAPHQL_API_PRODUCTION_ID,
      key: process.env.JAYCO_GRAPHQL_API_PRODUCTION_KEY,
      apiEndpoint: process.env.JAYCO_GRAPHQL_API_PRODUCTION_URL,
    }
  }

  return {
    // id: 'hv5gwdgwcjbh3dafl44p7bjebe',
    // key: 'da2-6wzdt6rrojbv5apvcy3i2olgne',
    // apiEndpoint: 'https://yirivsskf5batig6dxh6m2igqm.appsync-api.ap-southeast-2.amazonaws.com/graphql',
    id: process.env.JAYCO_GRAPHQL_API_PRODUCTION_ID || 'hv5gwdgwcjbh3dafl44p7bjebe',
    key: process.env.JAYCO_GRAPHQL_API_PRODUCTION_KEY || 'da2-6wzdt6rrojbv5apvcy3i2olgne',
    apiEndpoint: process.env.JAYCO_GRAPHQL_API_PRODUCTION_URL || 'https://yirivsskf5batig6dxh6m2igqm.appsync-api.ap-southeast-2.amazonaws.com/graphql',
  }

}

const authLink = setContext((_, { headers }) => {
  return {
    headers: {
      ...headers,
      'x-api-id': getVariables().id,
      'x-api-key': getVariables().key
    }
  }
});

const cache = new InMemoryCache();

const defaultOptions = {
  watchQuery: {
    fetchPolicy: 'no-cache',
    errorPolicy: 'ignore',
  },
  query: {
    fetchPolicy: 'no-cache',
    errorPolicy: 'all',
  },
}

const httpLink = createHttpLink({
  uri: getVariables().apiEndpoint,
  fetch: fetch,
});

const client = new ApolloClient({
  // Provide required constructor fields
  cache: cache,
  link: from([authLink, httpLink]), // Chain it with the HttpLink
  defaultOptions
});

export default client;
